<template>
  <div class="p-col-12">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <Dialog
      :visible.sync="show"
      :style="{ width: $isMobile() ? '100vw' : '50vw' }"
      :header="`Marcar Intervenção - Pat ${patId}`"
      :modal="true"
      :closable="false"
    >
      <div class="card">
        <form
          name="MarkInterventionForm"
          class="p-col-12"
          @submit.prevent="markIntervention"
          style="min-height: 30vh"
        >
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-3" v-if="!isEdit">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-calendar"></i>
                </span>
                <span class="p-float-label">
                  <v-date-picker
                    name="day"
                    id="day"
                    v-model="day"
                    v-validate="'required'"
                    :masks="{
                      input: 'YYYY-MM-DD',
                    }"
                      style="min-width: 100%;"
                  >
                    <template v-slot="{ inputValue, inputEvents }">
                      <span class="p-float-label">
                        <input
                          v-bind:class="[
                            'form-control',
                            'p-inputtext',
                            'p-component',
                            'p-filled',
                          ]"
                          :value="inputValue"
                          v-on="inputEvents"
                          autocomplete="off"
                        />
                        <label for="day">Dia</label>
                      </span>
                    </template>
                  </v-date-picker>
                </span>
              </div>
              <small v-if="errors.has('day')" class="p-error" role="alert"
                >Dia é obrigatório</small
              >
            </div>
            <div class="p-field p-col-12 p-md-9" v-if="!isEdit">
              <span class="p-float-label">
                <Dropdown
                  v-model="type"
                  :options="types"
                  v-validate="'required'"
                  v-bind:class="[
                    {
                      'p-invalid': errors.has('type'),
                    },
                    'form-control',
                  ]"
                  :name="'type'"
                  :id="'type'"
                  optionLabel="name"
                  optionValue="id"
                  :dataKey="'id'"
                  filter
                  appendTo="body"
                />
                <label for="type">Tipo de Intervenção</label>
              </span>
              <small v-if="errors.has('type')" class="p-error" role="alert">
                Tipo de Intervenção é obrigatório
              </small>
            </div>
            <div class="p-field p-col-12 p-md-12 p-mt-2">
              <span class="p-float-label">
                <Textarea
                  id="report"
                  name="report"
                  v-validate="'required'"
                  :autoResize="true"
                  v-model="report"
                  v-bind:class="[
                    'p-inputtextarea',
                    'p-inputtext',
                    'p-component',
                  ]"
                  rows="5"
                />
                <label for="inputtext">Relatório</label>
              </span>
              <small v-if="errors.has('report')" class="p-error" role="alert"
                >Relatório é obrigatório</small
              >
            </div>
            <div class="p-field p-col-12 p-md-3">
              <label for="cost_value">Valor</label>
              <InputNumber
                id="cost_value"
                v-model="cost_value"
                mode="currency"
                currency="EUR"
                locale="pt-PT"
                :minFractionDigits="2"
                :maxFractionDigits="6"
              />
            </div>
          </div>
        </form>
      </div>
      <template #footer>
        <Button
          :label="'Guardar'"
          icon="pi pi-save"
          class="p-button-success"
          @click="markIntervention"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="cancel"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import PatService from "@/services/pat.service";
import InterventionsService from "@/services/intervention.service";
import { getOnlyDate, getOnlyTime } from "@/helpers/helpers";
export default {
  name: "InterventionForm",
  props: {
    patId: {
      type: Number,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Object,
      default: null,
    },
  },
  watch: {
    show() {
      this.reset();
      if (this.show == true) {
        this.$validator.resume();
        if (this.isEdit) {
          this.report = this.edit.resume;
          this.cost_value = this.edit.cost_value;
        }
      } else {
        this.reset();
      }
    },
  },
  data() {
    return {
      day: new Date(),
      start: new Date(),
      end: new Date(new Date().getTime() + 60000),
      type: null,
      report: "",
      types: [],
      cost_value: 0,
      loading: false,
    };
  },
  async created() {
    this.types = await InterventionsService.getTypes();
  },
  computed: {
    isEdit() {
      return this.edit !== null;
    },
  },
  methods: {
    reset() {
      this.$validator.pause();
      this.$validator.reset();
      this.day = new Date();
      this.start = new Date();
      this.end = new Date(new Date().getTime() + 60000);
      this.type = null;
      this.report = "";
      this.cost_value = 0;
    },
    cancel() {
      this.reset();
      return this.$emit("close");
    },
    storeIntervention(bodyParams) {
      return PatService.addIntervention(this.patId, bodyParams).then(
        (response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: "Erro ao marcar intervenção",
              detail: "",
              life: 3000,
            });
          }
          this.$toast.add({
            severity: "success",
            summary: `Intervenção marcada com sucesso`,
            detail: ``,
            life: 3000,
          });

          return this.$emit("marked", response);
        }
      );
    },
    markIntervention() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid || !this.day) {
          return;
        }
        let bodyParams = {
          start: `${getOnlyDate(this.day)} ${getOnlyTime(this.start)}`,
          end: `${getOnlyDate(this.day)} ${getOnlyTime(this.end)}`,
          report: this.report,
          typeIntervention: this.type,
          cost_value: this.cost_value,
        };
        this.$validator.pause();
        this.$validator.reset();
        if (!this.isEdit) {
          return this.storeIntervention(bodyParams);
        }

        bodyParams.id = this.edit.id;
        return this.editIntervention(bodyParams);
      });
    },
    editIntervention(bodyParams) {
      return PatService.editIntervention(this.patId, bodyParams).then(
        (response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: "Erro ao editar intervenção",
                detail: "",
                life: 3000,
              });
            }
            this.$toast.add({
              severity: "success",
              summary: `Intervenção editada com sucesso`,
              detail: ``,
              life: 3000,
            });

            return this.$emit("marked", response);
          });
      }
  }
};
</script>
